var render = function render(_c,_vm){return _c('div',{staticClass:"ru:base-header"},[_c('div',{staticClass:"ru:grid"},[_c('div',{staticClass:"ru:cell --12/12 --6/12--md"},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"ru:cell --9/12 --6/12--md"},[_vm._t("right")],2)]),_vm._v(" "),_vm._t("extra")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }